import React from 'react';

import { cn } from 'src/component/ds/utils';

/* "Card - Vega" in Figma: 1px border, 16px padding, 8px gap between slots. */

function Card ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'ds-rounded-ds ds-border ds-border-border ds-bg-card ds-text-card-foreground',
        className
      )}
      {...props}
    />
  );
}

function CardHeader ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('ds-flex ds-flex-col ds-gap-1.5 ds-p-4', className)} {...props} />;
}

const CardTitle = React.forwardRef<HTMLHeadingElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => (
    <h3
      ref={ref}
      className={cn('ds-text-ds-h4 ds-font-medium ds-text-foreground', className)}
      {...props}
    />
  )
);
CardTitle.displayName = 'CardTitle';

const CardDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => (
    <p ref={ref} className={cn('ds-text-ds-sm ds-text-muted-foreground', className)} {...props} />
  )
);
CardDescription.displayName = 'CardDescription';

function CardContent ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('ds-p-4 ds-pt-0', className)} {...props} />;
}

function CardFooter ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('ds-flex ds-items-center ds-gap-2 ds-p-4 ds-pt-0', className)} {...props} />
  );
}

export { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter };
